import { RefObject, useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useClosestScrollContainer } from './useClosestScrollContainer';

export const useAvailableSpaceInScrollContainer = (
    element: RefObject<HTMLElement | null>, margins: number
) => {
    const [above, setAbove] = useState(0);
    const [below, setBelow] = useState(0);

    const container = useClosestScrollContainer(element);

    const updateDistances = useCallback(() => {

        if (element.current !== null && container.current !== null) {

            const availableSpace =
                calculateAvailableSpace(element.current, container.current, margins);

            setAbove(availableSpace.above);
            setBelow(availableSpace.below);
        }

    }, [element, container, margins]);

    useLayoutEffect(() => {
        const currentContainer = container.current;
        if (currentContainer !== null) {
            const onScroll = () => updateDistances();
            currentContainer.addEventListener('scroll', onScroll);
            return () => currentContainer.removeEventListener('scroll', onScroll);
        }
    }, [element, container, updateDistances]);

    useEffect(() => {
        if (container.current !== null) {
            updateDistances();
        }
    }, [container, updateDistances]);

    return { above, below };
};

const calculateAvailableSpace = (element: HTMLElement, container: HTMLElement, margins: number) => {

    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const scrollableSpaceAbove = -container.scrollTop;
    const scrollableSpaceBelow = element.scrollHeight - element.clientHeight - element.scrollTop;

    const distanceToTopEdge = elementRect.top - containerRect.top - margins;
    const distanceToBottomEdge = containerRect.bottom - elementRect.bottom - margins;

    return {
        above: distanceToTopEdge + scrollableSpaceAbove,
        below: distanceToBottomEdge + scrollableSpaceBelow
    };
};